import * as actionTypes from './actionTypes';

export const toggleAddPaymentModal = () => ({
   type: actionTypes.TOGGLE_ADD_PAYMENT_MODAL
})

export const toggleUpdatePaymentModal = (payment) => ({
   type: actionTypes.TOGGLE_UPDATE_PAYMENT_MODAL,
   payload: payment
})